import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { Token } from "../../common/models/token/token.model";
import { LocalStorageRepositoryInterface } from "../repositories/local-storage/local-storage.interface";
import { LoginDto } from "../../common/dtos/login/body/login.dto";

@Injectable({
  providedIn:"root"
})
export class AuthManager {

  constructor(
        private localRepository : LocalStorageRepositoryInterface
  ) {}

  public login(body: LoginDto): Observable<Token> {
    return this.localRepository.login(body).pipe(
      tap(
        (res)=> {
          this.localRepository.saveToken(res);
          this.localRepository.saveUsername(body.username);
        }
      )
    );
  }

  public logout(): void {
    this.localRepository.deleteToken();
  }

  public get logged():boolean {
    const token = this.localRepository.loadToken();
    return token !== null && token !== undefined && token.accessToken !== null;
    // return this.localRepository.loadToken()?.accessToken != null ?? false;
  }

  public getToken(): string | undefined {
    return this.localRepository.loadToken()?.accessToken;
  }

  public getUsername(): string | undefined {
    return this.localRepository.loadUsername()?.toString();
  }

}
